<template>
    <div class="user-edit">
        <el-drawer :title="formDrawer.title" :visible.sync="formDrawer.visible" direction="rtl" :before-close="closeDrawer">
            <div class="drawer-form">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="left">
                    <el-form-item label="用户角色" prop="role_id">
                        <el-select v-model="ruleForm.role_id" filterable clearable placeholder="请选择">
                            <el-option v-for="item in roleList" :key="item.id" :label="item.title" :value="item.id + ''"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属部门" prop="department_id">
                        <el-tree show-checkbox @check-change="checkDepartment" ref="departmentTree" :data="tree" node-key="id" highlight-current check-strictly auto-expand-parent :default-checked-keys="treeChecked" :default-expanded-keys="treeChecked">
                            <div class="custom-tree-node" slot-scope="{ node }">
                                <span>{{ node.label }}</span>
                            </div>
                        </el-tree>
                    </el-form-item>
                    <el-form-item label="登陆名称" prop="nickname">
                        <el-input v-model="ruleForm.nickname"></el-input>
                    </el-form-item>
                    <el-form-item label="真实姓名" prop="realname">
                        <el-input v-model="ruleForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item label="性别" prop="sex">
                        <el-radio-group v-model="ruleForm.sex">
                            <el-radio :label="'1'">男</el-radio>
                            <el-radio :label="'0'">女</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <template v-if="formDrawer.method == 'create'">
                        <el-form-item label="登陆密码" prop="password">
                            <el-input v-model="ruleForm.password" type="password" key="createPwd"></el-input>
                        </el-form-item>
                    </template>
                    <template v-if="formDrawer.method == 'edit'">
                        <el-form-item label="登陆密码">
                            <el-input v-model="ruleForm.password" type="password" key="editPwd"></el-input>
                        </el-form-item>
                    </template>

                    <el-form-item label="手机号" prop="mobile">
                        <el-input type="number" @keydown.down.native.prevent @keydown.up.native.prevent @mousewheel.native.prevent v-model="ruleForm.mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="座机" prop="telephone">
                        <el-input v-model="ruleForm.telephone"></el-input>
                    </el-form-item>
                    <el-form-item label="坐席密码" prop="sip_pwd">
                        <el-input v-model="ruleForm.sip_pwd"></el-input>
                    </el-form-item>
                    <el-form-item label="电话系统编号" prop="mobile_sys_id">
                        <el-input v-model="ruleForm.mobile_sys_id"></el-input>
                    </el-form-item>
                    <el-form-item label="云客手机开通" prop="is_open_yunke">
                        <el-select v-model="ruleForm.is_open_yunke" placeholder="云客手机开通">
                            <el-option label="开通" :value='1'></el-option>
                            <el-option label="未开通" :value='0'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="云客微信开通" prop="is_open_wechat">
                        <el-select v-model="ruleForm.is_open_wechat" placeholder="云客微信开通">
                            <el-option label="开通" :value='1'></el-option>
                            <el-option label="未开通" :value='0'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="uuid" prop="uuid">
                        <el-input v-model="ruleForm.uuid"></el-input>
                    </el-form-item>
                    <el-form-item label="钉钉" prop="dingding">
                        <el-input v-model="ruleForm.dingding"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="ruleForm.email"></el-input>
                    </el-form-item>
                    <el-form-item label="所在省份" prop="province_id">
                        <el-select v-model="ruleForm.province_id" placeholder="请选择" @change="provinceChange">
                            <el-option v-for="(item, index) in cityPicker" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所在城市" prop="city_id">
                        <el-select v-model="ruleForm.city_id" placeholder="请选择">
                            <el-option v-for="(item, index) in areaPicker" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="在职状态" prop="is_valid">
                        <el-select v-model="ruleForm.is_valid" placeholder="请选择">
                            <el-option v-for="(item, index) in statusList" :key="index" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input v-model="ruleForm.sort"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="footer-btn-imp">
                <el-button type="primary" @click="saveDrawer('ruleForm')">保存</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
let ruleForm = {
    id: 0,
    user_id: 0,
    store_id: '',
    department_id: '',
    role_id: '',
    province_id: '',
    city_id: '',
    nickname: '',
    realname: '',
    password: '',
    mobile: '',
    sex: '1',
    status: '',
    sort: 0,
    sip_pwd: '',
    is_open_yunke: 0,
    is_open_wechat: 0
};
export default {
    props: {
        roleList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            storeList: [],
            formDrawer: {
                title: '',
                visible: false,
                method: 'create'
            },
            tree: [],
            treeChecked: [], // 已选中的
            ruleForm: ruleForm,
            sexList: [{
                id: '0',
                title: '女'
            },
            {
                id: '1',
                title: '男'
            }
            ],
            statusList: [{
                id: 0,
                title: '离职'
            },
            {
                id: 1,
                title: '在职'
            }
            ],
            cityPicker: [], // 省份列表
            areaPicker: [], // 城市列表
            rules: {
                role_id: [{
                    required: true,
                    message: '请选择用户角色',
                    trigger: 'change'
                }],
                department_id: [{
                    required: true,
                    message: '请选择所属部门',
                    trigger: 'blur'
                }],
                nickname: [{
                    required: true,
                    message: '请输入登录名称',
                    trigger: 'blur'
                },
                {
                    min: 1,
                    max: 100,
                    message: '长度在 1 到 100 个字符',
                    trigger: 'blur'
                }
                ],
                realname: [{
                    required: true,
                    message: '请输入真实姓名',
                    trigger: 'blur'
                },
                {
                    min: 2,
                    max: 100,
                    message: '长度在 1 到 100 个字符',
                    trigger: 'blur'
                }
                ],
                sex: [{
                    required: true,
                    message: '请选择性别',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: '请输入登录密码',
                    trigger: 'blur'
                }],
                mobile: [{
                    required: true,
                    message: '请输入电话',
                    trigger: 'blur'
                },
                {
                    pattern: /^1\d{10}$/,
                    message: '手机号不合法',
                    trigger: ['blur', 'change']
                }
                ],
                province_id: [{
                    required: true,
                    message: '请选择省份',
                    trigger: 'change'
                }],
                city_id: [{
                    required: true,
                    message: '请选择城市',
                    trigger: 'change'
                }],
                is_valid: [{
                    required: true,
                    message: '请选择状态',
                    trigger: 'change'
                }]
                // sort: [{ required: true, message: '请输入排序号', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getPickerList();
    },
    methods: {
        // 获取下拉列表
        getPickerList() {
            let url = '/api/ucenter.picker/province';
            let that = this;
            this.$post(url, {}).then(function (res) {
                that.cityPicker = res.data.provinceList;
            });
        },
        // 获取部门树
        getTree() {
            let url = '/api/ucenter.department/getUserDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (res) {
                that.tree = res.data.tree;
            });
        },
        // 显示创建用户
        showCreateDrawer() {
            // 获取下拉列表
            this.getTree();
            this.formDrawer.title = '创建用户';
            this.formDrawer.visible = true;
            this.formDrawer.method = 'create';
            this.formDrawer.action = '/api/ucenter.user/save';
            this.ruleForm = Object.assign({}, ruleForm);
            this.$emit('getTableData');
        },
        // 显示编辑用户
        showEditDrawer(row) {
            // 获取下拉列表
            this.getTree();
            this.formDrawer.title = '编辑用户';
            this.formDrawer.visible = true;
            this.formDrawer.method = 'edit';
            this.formDrawer.action = '/api/ucenter.user/save';
            let that = this;
            let url = '/api/ucenter.user/read';
            let query = {
                id: row.id
            };
            that.$post(url, query).then(function (response) {
                if (response.code == '200') {
                    let treeDefaultChecked = [];
                    let user = response.data.user;
                    that.ruleForm = user;
                    treeDefaultChecked.push(user.department_id);
                    that.treeChecked = treeDefaultChecked;
                    that.provinceChange(user.province_id);
                } else {
                    that.$message.error(response.msg);
                }
            });
        },
        // 选择部门
        checkDepartment(data, checked) {
            if (checked) {
                this.$refs['departmentTree'].setCheckedNodes([data]);
                let resArr = this.$refs.departmentTree.getCheckedKeys().concat(this.$refs.departmentTree.getHalfCheckedKeys());
                this.ruleForm.department_id = resArr[0];
            }
        },

        // 保存 新增/编辑
        saveDrawer(formName) {
            let that = this;
            let query = this.ruleForm;
            let drawer = this.formDrawer;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$post(drawer.action, query).then(function (response) {
                        if (response.code == '200') {
                            that.$emit('getTableData');
                            that.closeDrawer();
                            that.$message.success(response.msg);
                        } else {
                            that.$message.error(response.msg);
                        }
                    });
                } else {
                    this.$message('请填写完整并检查您的填写信息');
                }
            });
        },
        // 清空内容
        closeDrawer() {
            this.formDrawer.visible = false;
            this.treeChecked = [];
            this.$refs['ruleForm'].resetFields();
        },
        // 所在省份变更，更新城市列表
        provinceChange(e) {
            let that = this;
            let url = '/api/ucenter.picker/city';
            let query = {
                id: e
            };
            this.$post(url, query).then((res) => {
                if (res.code == 200) {
                    that.areaPicker = res.data.cityList;
                    that.ruleForm.area_id = '';
                }
            });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/drawer.less');

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}

.footer-btn-imp {
    position: sticky;
    bottom: 3px;
    left: 0;
    right: 0;
    text-align: center;
    background: #ffffff;
    z-index: 1;
}
</style>
